import Repository from '@/repositories/connectorApp'

export default {
	
	createStoreConnection(type, config, action='') {
		return Repository.post(`/connection/${type}${action}.json`, config)
	},
	updateStore(itemId, config){
		return Repository.patch(`/crms/${itemId}.json`, config)
	},
	getConnections(type,params={}){
		return Repository.get(`/connection/${type}`,{params})
	},
	getConnection(type,connectorId){
		return Repository.get(`/connection/${type}/${connectorId}`)
	},
	addConnection(connectionId,{integrationType,...payload}){
		return Repository.put(`/connection/keap/${connectionId}/${integrationType}`,payload)
	},
	deleteConnection(type,connectionId,integrationType=""){
		return Repository.delete(`/connection/${type}/${connectionId}/${integrationType}`)
	},
	getIntegrationTypes(type){
		return Repository.get(`/connection/${type}/integration_types`)
	},
	deleteIntegration(type,connectionId){
		return Repository.delete(`/connection/${type}/${connectionId}/disconnect`)
	},
	getCustomFields(type){
		return Repository.get(`/connection/${type}/fields`)
	},
	updateConnectorStore(type, config, typeId=""){
		return Repository.patch(`/connection/${type}${ typeId ? '/'+typeId : "" }.json`, config)
	},
	getAbandonedCartSaverStatus(type, params){
		return Repository.get(`/connection/${type}`, {params})
	},
	getMappedFields(type, connectionId, params={}){
		return Repository.get(`/connection/${type}/${connectionId}/mapped_fields`,{params})
	},
	getDomainNames(type, params={}){
		return Repository.get(`/connection/${type}/get_domain_names`,{params})
	},
	updateConnection(type, connectionId, config){
		return Repository.patch(`/connection/${type}/${connectionId}/update_connection`, config)
	}
}